var React = require('react');

function ExpandSquare (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M14 4L20 4V10","stroke":"#130A09","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M11 19H5L5 13","stroke":"#130A09","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

ExpandSquare.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ExpandSquare;

ExpandSquare.default = ExpandSquare;
